import FormJaivana from 'dashboard_jaivana_v1';


/**
 * @description Custom con funciones adicionales al formulario de Kits Componentes
 * @author Juan David Nieto
 * @version 1.0
 **/
class CustomKitsComponentes extends FormJaivana.form
{
constructor(props)
    {
        super(props);
        this.initForm                                   =   this.initForm.bind(this);
        this.traerKitsProduccion                        =   this.traerKitsProduccion.bind(this);
        this.successKitsProduccion                      =   this.successKitsProduccion.bind(this);
        this.onSelectionChanged                         =   this.onSelectionChanged.bind(this);
        this.gridOptionsKitsProduccion                  =   Object.assign({},this.gridOptions);
        this.gridOptionsKitsProduccion['onSelectionChanged']=   this.onSelectionChanged;
        this.gridOptionsKitsComponentes                 =   Object.assign({},this.gridOptions);
        this.setButtonSeleccionar                       =   this.setButtonSeleccionar.bind(this); 
        this.seleccionarItem                            =   this.seleccionarItem.bind(this);
        this.traerComponentesKits                       =   this.traerComponentesKits.bind(this);
        this.successComponentesKits                     =   this.successComponentesKits.bind(this);
        this.setButtonEliminar                          =   this.setButtonEliminar.bind(this);  
        this.eliminarItem                               =   this.eliminarItem.bind(this);  
        this.modalAgregarComponenteKits                 =   this.modalAgregarComponenteKits.bind(this);           
        this.agregarComponenteKits                      =   this.agregarComponenteKits.bind(this);
        this.successAgregarComponenteKits               =   this.successAgregarComponenteKits.bind(this);             
        this.closeModalComponentes                      =   this.closeModalComponentes.bind(this);
        this.confirmDeleteCustomItem                    =   this.confirmDeleteCustomItem.bind(this);
        this.successDeleteItem                          =   this.successDeleteItem.bind(this);
        this.cleanCantidadFactor                        =   this.cleanCantidadFactor.bind(this);
        this.filaSeleccionada   = [];
        this.id_delete = 0;
    }
initForm()
    {
        console.log("Kits Componentes @version 1.01.0018, @author Mario A. Sepúlveda");

        this.traerKitsProduccion();
        this.getField('agregar').setVisible(false);
        this.getField('agregar').setClick(this.modalAgregarComponenteKits);
        this.getField('agregar_componente').setClick(this.agregarComponenteKits);
        this.getField('cancelar').setClick(this.closeModalComponentes);
        this.getField('codigo_articulo').setOnChange(this.cleanCantidadFactor);
    }
onSelectionChanged(){//funcion que permite seleccionar un articulo de la tabla
        //let selectedRows = this.gridOptionsPortafolio.api.getSelectedRows();
        this.filaSeleccionada = this.gridOptionsKitsProduccion.api.getSelectedRows();  
       let ItemIdSeleccionado = this.filaSeleccionada[0].kits_id;
       if(ItemIdSeleccionado !== this.getField('produccion_kits_id').getValue() && this.getField('produccion_kits_id').getValue() !== ''){
            this.getField('agregar').setVisible(false);
            this.getField('tabla_kits_componentes').toggle(false);
        }
                  
    }
cleanCantidadFactor(){
    this.getField('cantidad').setValue('');
    this.getField('factor').setValue('');
}
traerKitsProduccion(){

    let datos = {
        datos:{
        }
    }

    this.generalFormatPmv = { tipo_servicio: 'prod-kits', operacion: 'todos', operacion_tipo: 'consulta' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'GET',
        body: datos,
        success: this.successKitsProduccion,
        error: this.error_,
        showMessage: false,
        general: this.generalFormatPmv
    });
    //prod-kits-todos
    /*let body = {
    }
        this.generalFormat.nombre_accion = '390-Retorna_kits_todos';
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success: this.successKitsProduccion, 
                error:this.error_,
                general: this.generalFormat 
            });*/
}
successKitsProduccion(data){
    if(data.estado_p === 200){
        if(data.model && data.model.length>0){
            //console.log('entro al traer datos tabla',data.model);

            let newArr = [];

            data.model.find( element => {
                if(element.estadoactivo_id === 1){
                    
                    newArr.push(element);
                }
                return null
            });

            //console.log('Nuevo array sin kits inactivos',newArr.length,'array antiguo',data.model.length);

            //this.gridOptionsKitsProduccion['rowData'] = data.model;
            this.gridOptionsKitsProduccion['rowData'] = newArr;
            let configCell = new Map();
                configCell.set('seleccionar',{cellRenderer:this.setButtonSeleccionar ,field: 'seleccionar',width:150});
                this.getField('tabla_componentes').initData(this.gridOptionsKitsProduccion,configCell);
              
        }else{//de lo contrario no se muestra tabla
            this.getField('tabla_componentes').toggle(false); 
        }   
    }         
}
setButtonSeleccionar(props){
    let button = document.createElement("input"); 
    button.onclick = ()=>this.seleccionarItem(props);//toma el id del regirtro seleccionado en la tabla
    button.setAttribute("id",'button_aprove_');
    button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
    button.setAttribute("type","button");
    button.setAttribute("value","Seleccionar");
    return this.createElementJaivana(button);
}
seleccionarItem(props){
    this.getField('tabla_kits_componentes').toggle(false);
    this.getField('agregar').setVisible(true);
    this.getField('produccion_kits_id').setValue(props.data.kits_id);
    this.traerComponentesKits();

}
traerComponentesKits(){
    if(this.getField('produccion_kits_id').getValue() !== ''){

        let datos = {
            datos:{
                value:this.getField('produccion_kits_id').getValue()+"",
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-kitscomponentes', operacion: 'kitid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successComponentesKits,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
        /*let body = {
            value:this.getField('produccion_kits_id').getValue(),
        }
            this.generalFormat.nombre_accion = '390-Retorna_componentes_kit_kitid';
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'GET',
                    body:body,
                    success: this.successComponentesKits, 
                    error:this.error_,
                    general: this.generalFormat 
                });*/
    }
}
successComponentesKits(data){
    if(data.estado_p === 200){
        if(data.model && data.model.length>0){
            this.gridOptionsKitsComponentes['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('eliminar',{cellRenderer:this.setButtonEliminar ,field: 'eliminar',width:150});
            this.getField('tabla_kits_componentes').initData(this.gridOptionsKitsComponentes,configCell);
                             
        }else{//de lo contrario no se muestra tabla
            this.getField('tabla_kits_componentes').toggle(false); 
        }   
    }  
}
setButtonEliminar(props){
    let button = document.createElement("input"); 
    button.onclick = ()=>this.eliminarItem(props);//toma el id del regirtro seleccionado en la tabla
    button.setAttribute("id",'button_aprove_');
    button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
    button.setAttribute("type","button");
    button.setAttribute("value","Eliminar");
    return this.createElementJaivana(button);
}
eliminarItem(props){
    this.id_delete = props.data.id;
    this.getField('confirmModalCustom').setTitleAndContent('Eliminar','Desea realizar esta operación?');
    this.getField('confirmModalCustom').setClickDialog(this.confirmDeleteCustomItem);
    this.getField('confirmModalCustom').toggle(true);
}
confirmDeleteCustomItem(){
    this.getField('confirmModalCustom').toggle(false);
    let datos = {
        datos:{
            id_form_390:this.id_delete,
        }
    }

    this.generalFormatPmv = { tipo_servicio: 'prod-kitscomponentes', operacion: '7', operacion_tipo: 'eliminar' };
    this.service.send(
    {
        endpoint: this.constant.formConfiguration(),
        method:'DELETE',
        body: datos,
        success: this.successDeleteItem,
        error: this.error_,
        showMessage: false,
        general: this.generalFormatPmv
    });
        /*let body = {
            id:this.id_delete,
        }
            this.generalFormat.nombre_accion = '390-Elimina_componentes_kits';
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'DELETE',
                    body:body,
                    success: this.successDeleteItem, 
                    error:this.error_,
                    general: this.generalFormat 
                });*/
}
successDeleteItem(data){
    if(data.estado_p === 200){
        this.traerComponentesKits();
        this.id_delete = 0;
    }
}
modalAgregarComponenteKits(){
    this.getField('modal_componentes').handleClickOpen();
    this.cleanCantidadFactor();
}
agregarComponenteKits(){
    if(this.getField('codigo_articulo').valid() && this.getField('descripcion_articulo').valid() &&
       this.getField('cantidad').valid() && this.getField('factor').valid() && 
       this.getField('produccion_kits_id').getValue() !== '' && this.getField('articulo_id').getValue() !== ''){
        
        let datos = {
            datos:{
                produccion_kits_id:this.getField('produccion_kits_id').getValue(),
                articulo_id:this.getField('articulo_id').getValue(),
                cantidad:this.getField('cantidad').getValue(),
                factor:this.getField('factor').getValue()
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-kitscomponentes', operacion: '5', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successAgregarComponenteKits,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });

        /*let body = {
            produccion_kits_id:this.getField('produccion_kits_id').getValue(),
            articulo_id:this.getField('articulo_id').getValue(),
            cantidad:this.getField('cantidad').getValue(),
            factor:this.getField('factor').getValue()
        }
            this.generalFormat.nombre_accion = '390-Crea_componentes_kits';
            this.service.send(
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'POST',
                    body:body,
                    success: this.successAgregarComponenteKits, 
                    error:this.error_,
                    general: this.generalFormat 
                });*/
    }
}
successAgregarComponenteKits(data){
    if(data.estado_p === 200){
        this.closeModalComponentes();      
    }
}
closeModalComponentes(){
    this.getField('modal_componentes').handleClose();  
    this.traerComponentesKits();
}
}
FormJaivana.addController('prod-kitscomponentes',CustomKitsComponentes);
export default CustomKitsComponentes;
